import React, { useEffect, useState } from "react";
import axios from "axios";
import "./PaymentSuccess.css";
import Success from "../../myimgs/Seccess.png";
import { Link } from "react-router-dom";

const PaymentSuccess = () => {
  const [isProcessing, setIsProcessing] = useState(true);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchCaptureOrder = async () => {
      try {
        // 🟢 Get the orderId from localStorage
        const orderId = localStorage.getItem("paypalOrderId");

        if (!orderId) {
          console.error("❌ Order ID not found in localStorage");
          setIsProcessing(false);
          return;
        }

        console.log("📦 Capturing Order:", orderId);

        // 🟢 Call the capture order API
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/paypal/capture-order/${orderId}`
        );

        console.log("✅ Capture Order Response:", response.data);

        if (response.status === 200) {
          setSuccess(true);
          // Optional: clear the saved orderId after success
          localStorage.removeItem("paypalOrderId");
        } else {
          console.error("❌ Payment capture failed");
        }
      } catch (error) {
        console.error("❌ Error capturing payment:", error);
      } finally {
        setIsProcessing(false);
      }
    };

    fetchCaptureOrder();
  }, []);

  return (
    <div className={`payment-page ${isProcessing ? "blurred" : ""}`}>
      {/* Loader overlay during processing */}
      {isProcessing && (
        <div className="processing-overlay">
          <div className="loader"></div>
          <h2>Processing your payment...</h2>
          <p>Please wait a moment.</p>
        </div>
      )}

      {/* Main content (blurred when loading) */}
      {!isProcessing && (
        <>
          {success ? (
            <>
              <div className="bgyui">
                <img src={Success} alt="Success" />
              </div>
              <div className="success-container">
                <h1>Payment Successful!</h1>
                <p>Thank you for your purchase.</p>
                <Link to="/propertyDetail">
                  <button>Return to Pages</button>
                </Link>
              </div>
            </>
          ) : (
            <div className="error-container">
              <h1>Payment Failed!</h1>
              <p>Something went wrong while capturing your payment.</p>
              <Link to="/propertyDetail">
                <button>Go Back</button>
              </Link>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PaymentSuccess;
